// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"50be592f","178":"5f319700","293":"8acb60c9","544":"d52a9814"}[chunkId] + ".chunk.js";
};